export const splitArray = <T extends unknown>(array: T[] | undefined, index: number): [T[], T[]] => {
	return [(array ?? []).slice(0, index), (array ?? []).slice(index, array?.length ?? 0)];
};
